import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProductGroupTypeDto } from '../../../../generated-model/models';
import { PageResponse } from '../../../shared/commons/page-response';

@Injectable({ providedIn: 'root' })
export class ProductGroupTypeService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/product-group-types';

  getAllProductGroupTypes(page: number, size: number, search: string = "", state: number | null = null): Observable<PageResponse<ProductGroupTypeDto>> { return this.http.get<PageResponse<ProductGroupTypeDto>>(this.apiUrl + '?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search) + (state == null ? '' : '&state=' + state)); }
  getProductGroupTypeById(id: number): Observable<ProductGroupTypeDto> { return this.http.get<ProductGroupTypeDto>(`${this.apiUrl}/${id}`); }
  createProductGroupType(dto: ProductGroupTypeDto): Observable<ProductGroupTypeDto> { return this.http.post<ProductGroupTypeDto>(this.apiUrl, dto); }
  updateProductGroupType(id: number, dto: ProductGroupTypeDto): Observable<ProductGroupTypeDto> { return this.http.put<ProductGroupTypeDto>(`${this.apiUrl}/${id}`, dto); }
  deleteProductGroupType(id: number): Observable<void> { return this.http.delete<void>(`${this.apiUrl}/${id}`); }
}
